// extracted by mini-css-extract-plugin
export default {"box":"Box_box__JfnLw","description":"Box_description__6JbSW","title":"Box_title__wirAe","icon":"Box_icon__gX2PJ"};